"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BaseBox = _styledComponents["default"].div.withConfig({
  displayName: "Box__BaseBox",
  componentId: "sc-186zw7e-0"
})(function (props) {
  var _props$theme$globalSi, _props$theme$globalSi2, _props$theme$globalSi3;

  return (0, _styledComponents.css)(["display:block;padding:", ";width:", ";height:", ";"], (_props$theme$globalSi = props.theme.globalSizes[props.padding]) !== null && _props$theme$globalSi !== void 0 ? _props$theme$globalSi : props.padding, (_props$theme$globalSi2 = props.theme.globalSizes[props.boxWidth]) !== null && _props$theme$globalSi2 !== void 0 ? _props$theme$globalSi2 : props.boxWidth, (_props$theme$globalSi3 = props.theme.globalSizes[props.boxHeight]) !== null && _props$theme$globalSi3 !== void 0 ? _props$theme$globalSi3 : props.boxHeight);
});
/**
 * ### Layout primitive component
 *
 * The `Box` component is a fixed size container which is used to create dynamic, wrapping layouts.
 *
 * When placed in a `Stack` component, a `Box` will behave as governed by the **flex** properties of that `Stack`.
 *
 * Boxes are the fundamental building blocks of our layout system. They are a basic block-level element.
 *
 * If you require something to be positioned by another layout primitive (a Stack, Cluster, Row etc) place it in a Box.
 *
 * It can render pretty much any HTML element - the element to render should be passed in the "element" prop.
 */


var Box = /*#__PURE__*/_react["default"].forwardRef(function Box(_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'div' : _ref$element,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'none' : _ref$padding,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      rest = _objectWithoutProperties(_ref, ["children", "className", "element", "padding", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement(BaseBox, _extends({
    as: element,
    boxWidth: width,
    boxHeight: height,
    className: className,
    padding: padding,
    ref: ref
  }, rest), children);
});

var _default = Box;
exports["default"] = _default;